import { guid } from '@wix/wix-vod-shared/src/common/utils/guid';

export default class CorrelatedBiEventsChain {
  constructor(resetEventName, ...eventNames) {
    this.eventNames = [resetEventName, ...eventNames];
    this.resetEventName = resetEventName;

    this.correlationId = guid();
  }

  updateCorrelationId() {
    this.correlationId = guid();
  }

  isSupportedEvent(eventName) {
    return _.includes(this.eventNames, eventName);
  }

  isResetEvent(eventName) {
    return eventName === this.resetEventName;
  }

  getCorrelationId(eventName) {
    if (!this.isSupportedEvent(eventName)) {
      return null;
    }

    if (this.isResetEvent(eventName)) {
      this.updateCorrelationId();
    }

    return this.correlationId;
  }
}



// WEBPACK FOOTER //
// ./src/shared/bi/correlation/chain.js